import { render } from "./SupportModal.vue?vue&type=template&id=4ac3f668&scoped=true"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"

import "./SupportModal.vue?vue&type=style&index=0&id=4ac3f668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac3f668"]])

export default __exports__